import CustomForm from '../custom_form.js';

class PreRegisterForm extends CustomForm {
  bindEvent() {
    $('#patient_email').on('keyup', (e) => this.validate(e.target.value))
    $('#patient_email').on('input', (e) => this.validate(e.target.value))
  }

  validate(email) {
    this.isValid = new RegExp(/^[^@\s]+@[^@\s]+$/).test(email)
    const submitBtn = $(this.object).find(':input[type=submit]')
    this.isValid
      ? submitBtn.removeClass('disabled')
      : submitBtn.addClass('disabled')
  }
}

window.PreRegisterForm = PreRegisterForm
